<template>
  <div>
    <Modal :title="editRoleName ? `编辑角色「${editRoleName}」` : `添加角色`" v-model="editRoleModal" width="800">
      <Alert show-icon type="error" v-if="editRoleError">{{ editRoleErrorMsg }}</Alert>
      <Form ref="editRoleForm" :model="editRoleForm" :rules="editRoleRules">
        <FormItem label="名称" style="width: 100%" prop="name">
          <Input v-model="editRoleForm.name" />
        </FormItem>
        <FormItem label="描述" style="width: 100%" prop="description">
          <Input v-model="editRoleForm.description" type="textarea" :rows="4" placeholder="（选填）" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="editRoleSubmit" :loading="editRoleSubmitting">提交</Button>
        <Button @click="editRoleModal = false">取消</Button>
      </div>
    </Modal>
    <Card shadow class="content">
      <div class="main">
        <Alert v-if="error" show-icon type="error">
          获取数据失败
          <a style="float: right;" v-on:click="getRoles"><Icon type="md-refresh" size="18" /></a>
        </Alert>
        <div v-else>
          <Row>
            <h4 style="float: left">角色列表</h4>
            <div style="float: right;" class="align-right">
              <Button :style="{marginRight: '10px', marginBottom: '10px'}" icon="md-refresh" @click="getRoles">刷新</Button>
              <Button
                @click="openEditModal"
                :style="{marginBottom: '10px'}"
                icon="md-add">添加角色</Button>
            </div>
          </Row>
          <Table
            :loading="tableLoading"
            ref="table"
            :data="roles"
            :columns="columns">
          </Table>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudRole, editPrivateCloudRole, deletePrivateCloudRole } from '@/api/private-cloud/role'

export default {
  name: 'role',
  data () {
    return {
      error: false,
      roles: [],
      columns: [
        {
          title: '角色名称',
          key: 'name',
          align: 'center',
          minWidth: 150
        },
        {
          title: '角色ID',
          key: 'id',
          align: 'center',
          minWidth: 200
        },
        {
          title: '操作',
          align: 'center',
          width: 170,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.openEditModal(params.row)
                  }
                }
              }, '编辑'),
              h('Poptip', {
                props: {
                  confirm: true,
                  placement: 'bottom',
                  transfer: true,
                  title: '你确定要删除该角色吗？'
                },
                on: {
                  'on-ok': () => {
                    this.deleteRole(params.row.id)
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  }
                }, '删除角色')
              ])
            ])
          }
        }
      ],
      tableLoading: false,
      // 编辑角色
      editRoleModal: false,
      editRoleSubmitting: false,
      editRoleError: false,
      editRoleErrorMsg: null,
      editRoleName: null,
      editRoleForm: {
        id: '',
        name: '',
        description: ''
      },
      editRoleRules: {
        name: { required: true, message: '名称是必填的', trigger: 'blur' }
      }
    }
  },
  created: function () {
    this.getRoles()
  },
  methods: {
    getRoles () {
      this.tableLoading = true
      getPrivateCloudRole().then(res => {
        this.roles = res.data.roles
        this.error = false
        this.tableLoading = false
      }).catch(res => {
        this.error = true
        this.tableLoading = false
        console.error(res.response)
      })
    },
    openEditModal (row) {
      if (row) {
        this.editRoleForm = {
          id: row.id,
          name: row.name,
          description: row.description
        }
        this.editRoleName = row.name
      } else {
        this.editRoleForm.id = ''
        this.editRoleName = null
      }
      this.editRoleModal = true
    },
    editRoleSubmit () {
      this.$refs.editRoleForm.validate((valid) => {
        if (valid) {
          this.editRoleSubmitting = true
          editPrivateCloudRole(this.editRoleForm, this.editRoleForm.id).then(res => {
            this.editRoleSubmitting = false
            this.editRoleError = false
            this.editRoleErrorMsg = null
            this.editRoleModal = false
            this.getRoles()
            this.$Notice.success({title: '操作成功'})
          }).catch(res => {
            this.editRoleSubmitting = false
            console.error(res.response)
            this.$Notice.error({title: '操作失败'})
            this.editRoleErrorMsg = res.response.data
            this.editRoleError = true
          })
        }
      })
    },
    deleteRole (id) {
      deletePrivateCloudRole(id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getRoles()
      }).catch(res => {
        if (res.response) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.response.data
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
